import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// Submit Email for forgot password MFA
const submitEmail = async (email) => {

  let status = STATUSES.SUCCESS;
  /*{
    "emailAddress":"",
  }*/
  let body = {
    "emailAddress": email,
  }

  const url = "/api/forgotPwd/requestToken";
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {
    //console.log("submitEmail()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { submitEmail }